(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["open-closed-forms"] && !Shopify.designMode) return;
  try {
    function openLectureFromHash() {
  if (window.location.hash !== '#open-closed-forms') return;
  const lecture = document.getElementById('open-closed-forms');
  if (!lecture) return;
  lecture.open = true;
}
document.addEventListener('click', function(event) {
  const link = event.target.closest('a[href="#open-closed-forms"]');
  const lecture = document.getElementById('open-closed-forms');
  if (link && lecture) lecture.open = true;
});
window.addEventListener('hashchange', openLectureFromHash);
openLectureFromHash();
  } catch(e) { console.error(e); }
})();

})();
